import {
  CREATE_DRIVER,
  CREATE_DRIVER_SUCCESS,
  GET_CARRIER_DRIVER_LIST,
  GET_DRIVER_LIST_ERROR,
  GET_DRIVER_LIST_SUCCESS,
  GET_DRIVERS_BY_CARRIER_ID,
  GET_DRIVERS_BY_CARRIER_ID_SUCCESS,
  REMOVE_DRIVER,
  REMOVE_DRIVER_SUCCESS,
  UPDATE_DRIVER_FAILURE,
  SET_DRIVER_LIST_LOADING,
  SET_DRIVERS_BY_CARRIER_ID_LOADING,
  UPDATE_DRIVER,
  UPDATE_DRIVER_SUCCESS,
} from '../constants/ActionTypes';

export const createDriver = (carrierId, supervisor, driver) => ({
  type: CREATE_DRIVER,
  payload: { carrierId, supervisor, driver },
});

export const createDriverSuccess = driver => ({
  type: CREATE_DRIVER_SUCCESS,
  payload: { driver },
});

export const getCarrierDriverList = carrierId => ({
  type: GET_CARRIER_DRIVER_LIST,
  payload: { carrierId },
});

export const getDriversByCarrierId = carrierId => ({
  type: GET_DRIVERS_BY_CARRIER_ID,
  payload: { carrierId },
});

export const getDriversByCarrierIdSuccess = (carrierId, drivers) => ({
  type: GET_DRIVERS_BY_CARRIER_ID_SUCCESS,
  payload: { carrierId, drivers },
});

export const getDriverListError = () => ({
  type: GET_DRIVER_LIST_ERROR,
});

export const getDriverListSuccess = payload => ({
  type: GET_DRIVER_LIST_SUCCESS,
  payload,
});

export const removeDriver = (driverId, supervisorId) => ({
  type: REMOVE_DRIVER,
  payload: { driverId, supervisorId },
});

export const removeDriverSuccess = driverId => ({
  type: REMOVE_DRIVER_SUCCESS,
  payload: { driverId },
});

export const setDriverListLoading = (isLoading = false) => ({
  type: SET_DRIVER_LIST_LOADING,
  payload: { isLoading },
});

export const setDriversByCarrierIdLoading = (carrierId, loading) => ({
  type: SET_DRIVERS_BY_CARRIER_ID_LOADING,
  payload: { carrierId, loading },
});

export const updateDriver = (carrierId, driverId, supervisor, driver) => ({
  type: UPDATE_DRIVER,
  payload: { carrierId, driverId, supervisor, driver },
});

export const updateDriverSuccess = driver => ({
  type: UPDATE_DRIVER_SUCCESS,
  payload: { driver },
});

export const updateDriverFailure = () => ({
  type: UPDATE_DRIVER_FAILURE,
});
